"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.TagGroup = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icon_1 = require("../icon");
var config_context_1 = require("../_util/config-context");
var create_rocket_1 = require("../_util/create-rocket");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.TagGroup = create_rocket_1.createRocket("TagGroup", "div.@{prefix}-tag-group");
exports.Tag = forward_ref_with_statics_1.forwardRefWithStatics(function Tag(_a, ref) {
    var _b;
    var children = _a.children, onClose = _a.onClose, className = _a.className, theme = _a.theme, dark = _a.dark, props = tslib_1.__rest(_a, ["children", "onClose", "className", "theme", "dark"]);
    var hasCloseHandler = typeof onClose === "function";
    var classPrefix = config_context_1.useConfig().classPrefix;
    var classSuffix = dark ? "-dark" : "";
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-tag", className, (_b = {},
            _b[classPrefix + "-tag--unlimited-width"] = true,
            _b[classPrefix + "-tag--edit"] = hasCloseHandler,
            _b["is-blue" + classSuffix] = theme === "primary",
            _b["is-success" + classSuffix] = theme === "success",
            _b["is-warning" + classSuffix] = theme === "warning",
            // @ts-ignore
            _b["is-error" + classSuffix] = theme === "danger" || theme === "error",
            _b)) }, props),
        react_1.default.createElement("span", null, children),
        hasCloseHandler && react_1.default.createElement(icon_1.Icon, { link: true, type: "dismiss", onClick: onClose })));
}, {
    Group: exports.TagGroup,
});
exports.Tag.displayName = "Tag";
//# sourceMappingURL=Tag.js.map